import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { take } from 'rxjs/operators';

import { AppState } from '../../../state';
import { selectIsGranted } from '../../../state/user/user.selectors';

@Injectable({
  providedIn: 'root',
})
export class PrivilegeService {
  hasPrivilege(section = '', action = 'view'): boolean {
    let hasPrivilege = false;

    if (!section) {
      return true;
    }

    this.store
      .pipe(select(selectIsGranted, { section, action }), take(1))
      .subscribe((isGranted) => (hasPrivilege = isGranted));

    return hasPrivilege;
  }

  constructor(private store: Store<AppState>) {}
}
